import { render, staticRenderFns } from "./ParlaySubMenu.vue?vue&type=template&id=9a6abb54&scoped=true&"
import script from "./ParlaySubMenu.vue?vue&type=script&lang=js&"
export * from "./ParlaySubMenu.vue?vue&type=script&lang=js&"
import style0 from "./ParlaySubMenu.vue?vue&type=style&index=0&id=9a6abb54&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a6abb54",
  null
  
)

export default component.exports